import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-834617f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-map-wrapper board-map-wrapper-two" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "text-wrapper text-wrapper-two" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "unit" }
const _hoisted_6 = { class: "tool-tip" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-tip" }, null, -1))
const _hoisted_8 = { class: "time" }

import L from 'leaflet'
import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue'
import Text from '@/components/text'
import moment from 'moment'
import { queryBoardCommonDetail } from '@/api'
import { CODE_ENUM } from '@/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'b-text-s',
  props: ['id', 'name'],
  emits: 'on-edit',
  setup(__props, { emit: $emit }) {

const props = __props;




const command = (command: string) => {
  $emit(command)
}
onMounted(() => {
  queryDetail()
})

const varList = ref([])
const queryDetail = async () => {
  const id = props.id
  const res: any = await queryBoardCommonDetail({
    id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    varList.value = res.data || []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Text), {
        content: props.name
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.name), 1)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_el_dropdown, {
        onCommand: command,
        size: "small",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "on-edit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bedit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "on-delete" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bdel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { class: "icon" }, {
            default: _withCtx(() => [
              _createVNode(_component_MoreFilled)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(varList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "two",
          key: item
        }, [
          _createElementVNode("p", _hoisted_4, [
            _createVNode(_unref(Text), {
              content: item.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.value || '-'), 1)
              ]),
              _: 2
            }, 1032, ["content"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.unit), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(item.name), 1),
            (item.desc)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: item.desc,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["content"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('STATISTICS.bupdateTime')) + "：" + _toDisplayString(item.updateTime
              ? _unref(moment)(item.updateTime).format('YYYY-MM-DD HH:mm')
              : '-'), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})